/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "A bill appears here the day after a customer's billing period ends." |
*
* @param {Partner_Billing_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_empty_body = /** @type {((inputs?: Partner_Billing_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Abrechnung erscheint hier am Tag nach dem Ende des Abrechnungszeitraums eines Kunden.")
	return /** @type {LocalizedString} */ ("A bill appears here the day after a customer's billing period ends.")
});